import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fs-8" }

import { translate } from '@/languages/i18n'
import { ERROR_STATUS_HAS_CHANGED } from '@/constants/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_unref(translate)(_unref(ERROR_STATUS_HAS_CHANGED) + '_1')), 1),
    _createElementVNode("div", null, _toDisplayString(_unref(translate)(_unref(ERROR_STATUS_HAS_CHANGED) + '_2')), 1)
  ]))
}
}

})